import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Dropdown from '../dropdown';
import type { Predicate } from '@common/types/objects';
import { EPredicateOperators } from '@common/definitions';

type PredicateSelectorTextContainsProps = {
  predicate: Predicate;
  onChange: (newPredicate: Partial<Predicate>) => void;
};

export const PredicateSelectorTextContains = ({
  predicate,
  onChange: parentOnChange,
}: PredicateSelectorTextContainsProps) => {
  const { t } = useTranslation();
  const [search, setSearch] = useState(
    typeof predicate.value === 'string' ? predicate.value : ''
  );

  const handleSearch = (value: string | null) => {
    const nextValue = value ?? '';
    setSearch(nextValue);
    parentOnChange({
      comparison: EPredicateOperators.CONTAINS,
      value: nextValue.trim(),
    });
  };

  return (
    <Dropdown.SearchInput
      debounce={false}
      filter={false}
      placeholder={t('common:predicates_filter_user_property_search_placeholder')}
      defaultValue={search}
      onSearch={handleSearch}
    />
  );
};
